/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Row, Col, Container, Form, Button } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import { loaderActions } from '../../features/Loader/LoaderSlice';
import loginImg from './../../assets/images/emma-bg.png';
import loginImgSmall from './../../assets/images/emma-bg-small.png';
import './../../assets/scss/custom/Signup.scss';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';

const Signup = () => {
  const navigate = useNavigate();
  const [company, setCompany] = useState();
  const [matches, setMatches] = useState(window.matchMedia('(min-width: 1220px)').matches);
  const [inputList, setInputList] = useState([{ name: '', code: '' }]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [vcode, setVcode] = useState('');
  const dispatch = useDispatch();

  const [user, setUser] = useState({
    email: '',
    password: '',
    cpassword: '',
    vendor: []
  });

  const { email, password, cpassword } = user;

  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const bgStyleBig = {
    backgroundImage: `url(${loginImg})`,
    height: '%100',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat'
  };

  const bgStyleSmall = {
    backgroundImage: `url(${loginImgSmall})`,
    height: '%100',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat'
  };

  const handleSelects = (e, index) => {
    const { value } = e.target;
    const list = [...inputList];
    setSelectedCompany(value);
    list[index].name = value;
    setInputList(list);
  };

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    if (name === 'code') {
      setVcode(value);
      list[index][name] = e.target.value;
      if (list[index].name.trim() === '') {
        list[index].name = company[0].label;
      }
      setSelectedCompany(list[index].name);
    }
    setInputList(list);
  };

  const getCompany = () => {
    const url = process.env.REACT_APP_API_URL;
    const emmId = process.env.REACT_APP_COMP_EMM;
    const dunId = process.env.REACT_APP_COMP_DUN;

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*'
      }
    };

    try {
      dispatch(loaderActions.show());
      axios.get(`${url}/companies?(${emmId})`, config).then((response) => {
        if (
          response &&
          response.data &&
          response.data.value &&
          response.data.value.find((item) => item.companyBadgeText === 'EMM')
        ) {
          setCompany(response.data);
        } else {
          try {
            axios.get(`${url}/companies?(${dunId})`, config).then((response) => {
              if (
                response &&
                response.data &&
                response.data.value &&
                response.data.value.find((item) => item.companyBadgeText === 'DUN')
              ) {
                setCompany(response.data);
              }
            });
          } catch (err) {
            if (err.response) {
              console.error('Error occurred during addition\nError: ', err.response.data.message);
              toast.error(err.response.data.message, { id: 'error' });
            } else {
              console.error('Error occurred during brand addition process\nError: ', err);
              toast.error('Error occurred during brand addition process', { id: 'error' });
            }
          } finally {
            dispatch(loaderActions.hide());
          }
        }
      });
    } catch (err) {
      if (err.response) {
        console.error('Error occurred during addition\nError: ', err.response.data.message);
        toast.error(err.response.data.message, { id: 'error' });
      } else {
        console.error('Error occurred during brand addition process\nError: ', err);
        toast.error('Error occurred during brand addition process', { id: 'error' });
      }
    }
  };

  const signup = (inputList) => {
    const url = process.env.REACT_APP_API_URL;
    if (!email || email.length <= 0) {
      toast.error('Please enter complete email address', { id: 'email' });
    }
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      toast.error('Please enter a valid email address', { id: 'email' });
    } else if (!password || password.length <= 0) {
      toast.error('Please enter a valid password', { id: 'password' });
    } else if (!cpassword || cpassword.length <= 0) {
      toast.error('Please enter a valid confirm password', { id: 'password' });
    } else if (password !== cpassword) {
      toast.error('Passwords not match!', { id: 'password' });
    } else if (!/^(?=.{6,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W)/.test(password)) {
      toast.error('Please enter a valid password', { id: 'password' });
    } else if (vcode.length > 24) {
      toast.error('please enter vendor code less than 24 characters', { id: 'vendor' });
    } else if (inputList && (selectedCompany === '' || vcode === '')) {
      toast.error('Please enter an entity and vendor code', { id: 'vendor' });
    } else {
      dispatch(loaderActions.show());
      axios
        .post(
          `${url}/signup`,
          {
            email,
            Password: password,
            vendor: inputList
          },
          {
            headers: {
              'content-type': 'application/json',
              Accept: '*/*'
            }
          }
        )
        .then((result) => {
          if (result.status === 200) {
            SignupConfirmation();
          } else {
            toast.error('Sign Up Error!', { id: 'signup' });
            console.log('Sign Up Error!', result);
          }
        })
        .catch((error) => {
          if (error.response) {
            toast.error(`${error.response.data}`);
          }
        })
        .finally(() => {
          dispatch(loaderActions.hide());
        });
    }
  };

  function SignupConfirmation() {
    const url = process.env.REACT_APP_API_URL;
    axios
      .get(`${url}/userbase`, {
        headers: {
          'content-type': 'application/json',
          Accept: '*/*'
        }
      })
      .then((result) => {
        if (result.data.verification_method === 'CONFIRM_WITH_CODE') {
          Swal.fire(
            "You're almost done!",
            'An activation code has been sent to your email.',
            'success'
          ).then((result) => {
            navigate('/verify?email=' + email);
          });
        } else {
          Swal.fire(
            "You're almost done!",
            'An activation link has been sent to your email.',
            'success'
          );
        }
      });
  }

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { name: '', code: '' }]);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  useEffect(() => {
    window
      .matchMedia('(min-width: 1220px)')
      .addEventListener('change', (e) => setMatches(e.matches));
  }, []);

  useEffect(() => {
    if (typeof company === 'undefined') {
      getCompany();
    }
  }, []);

  useEffect(() => {
    if (company && typeof company.value !== 'undefined') {
      setCompany(
        company.value.map((t) => ({
          value: t.companyName,
          label: t.companyBadgeText,
          id: t.companyId
        }))
      );
      dispatch(loaderActions.hide());
    }
  }, [company]);

  return (
    <Container fluid className="signup-page" style={matches ? bgStyleBig : bgStyleSmall}>
      <Row>
        {matches ? <Col className="signup-col banner" sm={4}></Col> : null}
        <Col className="signup-col form" sm={8}>
          <Form>
            <Form.Group className="signup-col align-items-center ">
              <Form.Row className="signup-row ml-5">
                <p className="signup-form-header">Sign Up Emma Vendor Portal</p>
              </Form.Row>
            </Form.Group>
            <Form.Group className="signup-form align-items-center">
              <Form.Row>
                <Form.Group as={Col} controlId="formEmail" className="mt-3">
                  <label className="text-label"> E-mail Address:</label>
                  <Form.Control
                    className="signup_form"
                    as="input"
                    type="email"
                    name="email"
                    size="lg"
                    placeholder={'E-mail Address'}
                    value={email}
                    onChange={onChange}
                    autoComplete="email"
                    required
                  />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="formPassword">
                  <label className="text-label"> Password:</label>
                  <Form.Control
                    className="signup_form"
                    as="input"
                    type="password"
                    size="lg"
                    name="password"
                    placeholder={'Password'}
                    value={password}
                    onChange={onChange}
                    autoComplete="new-password"
                    required
                  />
                  <Form.Text className="text-muted mt-2">
                    Password should have at least 8 characters, 1 lower case, 1 upper case, 1
                    special character and 1 number
                  </Form.Text>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="formCPassword">
                  <label className="text-label">Confirm Password:</label>
                  <Form.Control
                    size="lg"
                    className="signup_form"
                    as="input"
                    type="password"
                    name="cpassword"
                    value={cpassword}
                    onChange={onChange}
                    placeholder={'Confirm Password'}
                    autoComplete="new-password"
                    required
                  />
                </Form.Group>
              </Form.Row>
              {typeof company !== 'undefined' ? (
                inputList.map((x, i) => {
                  return (
                    <Form.Row key={i}>
                      <div className="row">
                        <div className="col-5 align-self-center">
                          <label
                            className="floating-label"
                            htmlFor="entity"
                            style={{ fontSize: 16, textAlign: 'center' }}
                          >
                            Entity
                          </label>
                          <Form.Control
                            as="select"
                            className="form-control"
                            defaultValue={company[0]}
                            onChange={(e) => handleSelects(e, i)}
                          >
                            {Array.isArray(company) &&
                              company.map((obj) => {
                                return (
                                  <option key={obj.id} value={obj.label}>
                                    {obj.label}
                                  </option>
                                );
                              })}
                          </Form.Control>
                        </div>
                        <div className="col-5 align-self-center">
                          <label
                            className="floating-label"
                            htmlFor="entity"
                            style={{ fontSize: 16, textAlign: 'center' }}
                          >
                            Vendor Code
                          </label>

                          <input
                            className="form-control"
                            id="outlined-basic full-width-text-field"
                            label="Vendor Code"
                            name="code"
                            value={x.vCode}
                            maxLength={7}
                            onChange={(e) => handleInputChange(e, i)}
                          />
                        </div>
                        <div className="col-2 d-flex align-items-end">
                          {inputList.length !== 1 && (
                            <Button variant="danger" onClick={() => handleRemoveClick(i)}>
                              X
                            </Button>
                          )}
                        </div>
                      </div>
                      <div className="mt-4 ml-1 d-flex align-items-end">
                        {inputList.length - 1 === i && (
                          <Button
                            variant="success"
                            onClick={handleAddClick}
                            style={{ cursor: 'pointer' }}
                          >
                            +
                          </Button>
                        )}
                      </div>
                    </Form.Row>
                  );
                })
              ) : (
                <label style={{ color: '#FFFAF5' }}>
                  Unexpected error in loading entity list. Please try again after 10 minutes. If
                  issue persists, please contact support.
                </label>
              )}
              <Form.Row className="mt-3" color="#1E2B5A">
                {company ? (
                  <Button
                    variant="primary"
                    className="btn btn-block text-normal"
                    style={{ backgroundColor: '#1E2B5A', borderRadius: '5px' }}
                    onClick={() => signup(inputList)}
                    block
                  >
                    Sign up
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    className="btn btn-block text-normal"
                    style={{ backgroundColor: '#1E2B5A', borderRadius: '5px' }}
                    onClick={() => signup()}
                    disabled
                    block
                  >
                    Sign up (Firstly Select Entity)
                  </Button>
                )}
              </Form.Row>
              <Form.Row className="mt-2" color="#1E2B5A">
                <p className="mb-0 text-white">
                  Already have an account?{' '}
                  <Button variant="link" onClick={() => navigate('/login')}>
                    Login
                  </Button>
                </p>
              </Form.Row>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Signup;
